<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @close="alertContent=''"/>
    <div id="app-footer">
        <div id="footer-container"
             v-if="
             !$store.state.accountPage
            ">
            <div class="row">
                <div class="col-lg-5 col-sm-12 footer-container">
                    <div class="title-two">دسترسی سریع</div>
                    <div class="row">
                        <div class="col-6">
                            <div class="navigation-menu">
                                <ul v-if="categories">
                                    <li  v-for="(category,index) in categories" :key="category">
                                        <div v-if="index < 3"   v-on:click="$router.push('/category-view/'+category.slug)"  class="navigation-menu-text-content">
                                            <div class="navigation-menu-icon-content">
                                                <img class="arrow"  width="12" height="7" src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                            </div>
                                            {{category.name}}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="navigation-menu">
                                <ul v-if="categories">
                                    <li  v-for="(category,index) in categories" :key="category">
                                        <div v-if="index > 2 && index < 6"   v-on:click="$router.push('/category-view/'+category.slug)"  class="navigation-menu-text-content">
                                            <div class="navigation-menu-icon-content">
                                                <img class="arrow"  width="12" height="7" src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                            </div>
                                            {{category.name}}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7 col-sm-12 footer-container">
                    <div class="row" style="height: auto">
                        <div style="" class="col-5">
                            <div class="title-one">
                                راهنما
                            </div>

                            <div class="col-12">
                                <div class="navigation-menu">
                                    <ul>
                                        <li>
                                            <div v-on:click="$router.push('/about-us')" class="navigation-menu-text-content">
                                                <div class="navigation-menu-icon-content">
                                                    <img class="arrow"  width="12" height="7" src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                                </div>
                                                درباره ما
                                            </div>
                                            <div class="navigation-menu-text-content"  v-on:click="$router.push('/rules')" >
                                                <div class="navigation-menu-icon-content">
                                                    <img class="arrow"  width="12" height="7" src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                                </div>
                                                قوانین و مقررات
                                            </div>
                                            <div v-on:click="$router.push('/faq')" class="navigation-menu-text-content">
                                                <div class="navigation-menu-icon-content">
                                                    <img class="arrow"  width="12" height="7" src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                                </div>
                                                سوالات متداول
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div style="" class="col-7">
                            <div class="title-one"  v-if="contactInfos">
                                تماس با ما
                            </div>
                                <div class="col-12">
                                    <div class="navigation-menu">
                                        <ul>
                                            <li  v-if="contactInfos">
                                                <div class="navigation-menu-text-content" v-if="contactInfos.phone">
                                                    <div class="navigation-menu-icon-content">
                                                        <img class="arrow"  width="12" height="7" src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                                    </div>
                                                    <ul class="contact-data">
                                                        <li>تلفن:</li>
                                                        <li>{{contactInfos.phone}}</li>
                                                    </ul>
                                                </div>
                                                <div class="navigation-menu-text-content" v-if="contactInfos.address">
                                                    <div class="navigation-menu-icon-content">
                                                        <img class="arrow"  width="12" height="7" src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                                    </div>
                                                    <ul class="contact-data">
                                                        <li>آدرس:</li>
                                                        <li>{{contactInfos.address}}</li>
                                                    </ul>
                                                </div>
                                                <div class="navigation-menu-text-content" v-if="contactInfos.email">
                                                    <div class="navigation-menu-icon-content">
                                                        <img class="arrow"  width="12" height="7" src="../assets/appIcons/Icon/Filled/ArrowWhite.png" alt="">
                                                    </div>
                                                    <ul class="contact-data">
                                                        <li>ایمیل:</li>
                                                        <li>{{contactInfos.email}}</li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                        </div>


                        <div style="" class="col-12">
                            <div class="col-12">
                                    <div id="newsletter-input-content">
                                        <div>
                                            <input v-model="emailAddress" type="text" id="newsletter-input" placeholder="عضویت در خبرنامه با ارسال ایمیل...">
                                            <a :class="{'loading' : loadingMood}" id="newsletter-icon" v-on:click="storeEmailAddress()">
                                                <span v-if="loadingMood">
                                                       <span class="iconify" data-icon="uil:spinner-alt" data-inline="false"></span>
                                                </span>
                                                <span v-else>
                                                       <span class="iconify" data-icon="mdi-plus" data-inline="false"></span>
                                                </span>
                                            </a>

                                        </div>
                                    </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div id="footer-footer">
            <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12 footer-footer">
                    <a style="cursor: unset">
                        © کلیه حقوق این وب سایت برای  گروه مهاجرتی کانادا از ایران محفوظ است.
                    </a>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 footer-footer">
                    <span style="display: inline" v-if="contactInfos">     کانادا از ایران در شبکه های اجتماعی:</span>
                    <ul id="social-media" class="float-left" v-if="contactInfos">
                        <li v-if="contactInfos.facebook">
                            <a :href="contactInfos.facebook"   target="_blank">
                                <img class="non-colored" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Facebook.png" alt="icon">
                                <img class="colorful" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Hovered/Icon/SocialMedia/Facebook.png" alt="icon">
                            </a>
                        </li>
                        <li v-if="contactInfos.aparat">
                            <a :href="contactInfos.aparat"   target="_blank">
                            <img class="non-colored" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Aparat.png" alt="icon">
                            <img class="colorful" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Hovered/Icon/SocialMedia/Aparat.png" alt="icon">
                            </a>
                        </li>
                        <li v-if="contactInfos.instagram">
                            <a :href="contactInfos.instagram"   target="_blank">
                            <img class="non-colored" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Instagram.png" alt="icon">
                            <img class="colorful" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Hovered/Icon/SocialMedia/Instagram.png" alt="icon">
                            </a>
                        </li>
                        <li v-if="contactInfos.linkedIn">
                            <a :href="contactInfos.linkedIn"   target="_blank">
                            <img class="non-colored" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/LinkedIn.png" alt="icon">
                            <img class="colorful" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Hovered/Icon/SocialMedia/LinkedIn.png" alt="icon">
                            </a>
                        </li>
                        <li v-if="contactInfos.telegram">
                            <a :href="contactInfos.telegram"   target="_blank">
                            <img class="non-colored" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Telegram.png" alt="icon">
                            <img class="colorful" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Hovered/Icon/SocialMedia/Telegram.png" alt="icon">
                            </a>
                        </li>
                        <li v-if="contactInfos.youtube">
                            <a :href="contactInfos.youtube"    target="_blank">
                            <img class="non-colored" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Youtube.png" alt="icon">
                            <img class="colorful" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Hovered/Icon/SocialMedia/Youtube.png" alt="icon">
                            </a>
                        </li>
                        <li v-if="contactInfos.twitter">
                            <a :href="contactInfos.twitter"   target="_blank">
                            <img class="non-colored" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Twitter.png" alt="icon">
                            <img class="colorful" width="24" height="24" src="../assets/appIcons/Icon/SocialMedia/Hovered/Icon/SocialMedia/Twitter.png" alt="icon">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Alert from './Alert'
    import axios from 'axios'
    export default {
        name: "AppFooter",
        data(){
            return {
                showFooterContainer:true,
                emailAddress:null,
                loadingMood:false,
                alertContent:null,
            }
        },
        props: {
            categories:Object,
            contactInfos:Object,
        },
        components:{
            Alert,
        },
        methods:{
            async storeEmailAddress(){
                let checkSpace = this.emailAddress.replace(/\s/g, "");
                if(checkSpace !== ""){
                    try {
                        this.loadingMood = true;
                        await axios.post('api/storeNewsletterEmailAddress',{email:this.emailAddress}, {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                        this.loadingMood = false;
                        this.alertContent = {
                            message: 'آدرس ایمیل شما با موفقیت ثبت شد!',
                            imageUrl: require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                            buttonType: 'close',//close
                            buttonText: 'تایید',
                            buttonLink: '',///personal-info
                            waitingMode: false
                        };
                        this.emailAddress = null
                    }
                    catch (error) {
                        this.loadingMood = false;
                        this.alertContent = {
                            message: 'خطا در انجام عملیات!',
                            notice:error.response.data.errors,
                            imageUrl: require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                            buttonType: 'close',//close
                            buttonText: 'تایید',
                            buttonLink: '',///personal-info
                            waitingMode: false
                        };
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .loading{
        -webkit-animation:spin 1s linear infinite;
        -moz-animation:spin 1s linear infinite;
        animation:spin 1s linear infinite;
    }
    @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
    @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
    @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }


    #newsletter-input {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        border: none;
        background-color: rgb(33, 46, 64) !important;
        color: white !important;
    }
    #newsletter-icon {
        position: absolute;
        top: 10px;
        left: 10px;
        span{
            display: block;
            width: 16px;
            height: 20px;
        }
    }
    #newsletter-input-content {
        position: relative;
        width: 100%;
        height: 40px;
        float: right;
        border-radius: 10px;
        background-color: rgb(33, 46, 64) !important;
        color: white;
        padding: 0 15px;
        a{
            left: 0;
        }
    }

    #newsletter-input-content > div {
        display: inline-block;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    #newsletter-input-content > div:nth-child(2) {
        width: 40px;
        height: 40px;
        position: relative;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }

    #newsletter-input-content > div:nth-child(1) {
        width: 100%;
        height: 40px;
        /*background-color: blue;0020*/
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        position: relative;
    }

    #newsletter-input-content > div:nth-child(1) > input {
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        text-align: right;
        background-color: #ffffff;
        opacity: 0.5;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        /*color: #ffffff;*/

    }


    .col-5{
        padding: 0;
        margin: 0;
    }
    .col-7{
        padding: 0;
        margin: 0;
    }
    .col-12{
        padding: 0;
        margin: 0;
    }

    .col-6{
        padding: 0;
        margin: 0;
    }


    .row{
        margin: 0;
    }
    .footer-footer{
        padding: 0!important;
        span{
            opacity: 0.5;
        }
        a{
            opacity: 0.5;
        }
        margin-bottom: 10px;
        font-size: 12px;
        opacity: 1;
        text-align: right;
        color: white!important;
    }
    .footer-footer > a{
             color: white!important;
         }
    #social-media{
        padding: 0;
        list-style-type: none;
        display: inline;
    }
    #social-media>li{
       display: inline-block;
        width: 24px;
        height: 24px;
        margin-right: 15px;


        cursor: pointer;
    .colorful{
        display: none;
    }
    &:hover{
    .colorful{
        display: inline;
    }
    .non-colored{
        display: none;
    }
    }
    }
    .contact-data{
        padding: 0;
        list-style-type: none;
    }
    .contact-data>li{
        height: 100%;
        display: inline-block;
    }
    .contact-data>li:nth-child(2){
        text-align: left;
        width:calc(100% - 50px);
    }
    .contact-data>li:nth-child(1){
        text-align: right;
        width:50px;
    }
    @media(max-width: 500px){
        .contact-data>li{
            height: 100%;
            display: block;
        }
        .contact-data>li:nth-child(2){
            text-align: right;
            width:auto;
        }
        .contact-data>li:nth-child(1){
            text-align: right;
            width:auto;
        }
    }
    /*.row{*/
        /*padding: 0;*/
    /*}*/
    .footer-container{
        margin: 0;
        padding-right: 0;
        padding-left: 0;
        /*padding: 0;*/
    }
    .title-one{
        text-align: right;
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #ffffff;
    }
    .title-two{
        text-align: right;
        font-size: 18px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #ffffff;
    }
    .navigation-menu-text-content{
        font-size: 15px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #ffffff;
    }
    .navigation-menu>ul{
        list-style-type: none;
        width: 100%;
        height: 100%;
        position: relative;
        /*padding: 0;*/
        /*background-color: brown;0020*/
    }

    .navigation-menu>ul>li{
        cursor: pointer;
        display: block;
        margin: 15px 0 ;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: white;
    }

    .navigation-menu{

        display: block;
        /*opacity: 0;*/
        position: static;
        width: 100%;
        height: auto;
        /*margin: 0 164px 206px 18px;*/
        padding: 0;
        right: 0;
        margin: auto;
        border-radius: 10px;
        box-shadow: 0 5px 15px 1px rgba(22, 35, 54, 0.2);
        z-index: 500;
        text-align: right;
        color: white;
        background-color: #162336;
    }

    .navigation-menu-text-content{
        /*background-color: cadetblue;0020*/
        display: block;
        position: relative;
        margin: 5px 0;
    }

    .navigation-menu-text-content:hover{
        padding-right: 17px;
        transition: 0.05s;
    }

    .navigation-menu-text-content:hover .navigation-menu-icon-content {
        display: inline-block;
        transition: 0.05s;
    }


    #app-footer{
       height: auto;
        width: 100%;
        background-color: #162336;
    }
    #footer-container{
        margin: auto;
        width: 100%;
        max-width: 1150px;
    }
    #footer-footer{
        padding-right: 15px;
        padding-left: 15px;
        margin: 0  auto 0 auto;
        width: 100%;
        max-width: 1150px;
        height: auto;
        border-top: 2px solid rgba(116,116,116,0.5);;
        padding-top: 15px;
    }
    .footer-container{
        padding-top: 56px;
        padding-right: 0;
        padding-left: 0;

        margin-bottom: 30px;
    }
    @media(max-width: 550px){
        #social-media{
            margin-top: 15px;
        }
    }
    @media (max-width: 1300px) {
        .footer-container{
            padding-right: 15px;
            padding-left: 15px;
        }

    }
</style>